module.exports = __webpack_public_path__ + "static/img/1-2.560bdc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/1-2.jpg
// module id = 9PTW
// module chunks = 1